import styled from 'styled-components';

export const StyledBlocksSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-right: 1px solid #c6c6c6;
  overflow-y: auto;
`;

export const StyledBlockContainer = styled.div``;
